<template>
    <!--   </v-container>-->
    <v-sheet style="background-color:#fafafa;height:100%">
    <br>

    <v-row>
          <v-btn fab text small @click="prev">
            <v-icon small>mdi-chevron-left</v-icon>
          </v-btn>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-btn fab text small @click="next">
            <v-icon small>mdi-chevron-right</v-icon>
          </v-btn>
      </v-row>

      <br><br>
  
      <v-sheet height="600">
        <v-calendar
          ref="calendar"
          type="month"
          :now="today"
          v-model="focus"
          color="primary"
          :events="events"
          :event-color="getEventColor"
          :event-margin-bottom="3"
          @click:event="showEvent"
          @click:more="viewDay"
          @click:date="viewDay"
          @change="updateRange"
          :event-more="false"
        >
        </v-calendar>
        <v-menu
          v-model="selectedOpen"
          :close-on-content-click="false"
          :activator="selectedElement"
          full-width
          offset-x
        >
          <v-card
            color="grey lighten-4"
            min-width="350px"
            flat
          >
            <v-toolbar
              :color="selectedEvent.color"
              dark
            >
              <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
              <div class="flex-grow-1"></div> 
            </v-toolbar>
            
            <v-card-text>
              <v-layout wrap>
                <v-flex xs12 md4>
                <v-img
                      width="70px"
                      v-if="selectedEvent.thumb"
                      :src="get_cover_url(selectedEvent.thumb)"
                      text-left
                  />
                </v-flex>
                <v-flex xs12 md8>
                  <span v-html="selectedEvent.details"></span>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>             
               <v-btn
                dark
                color="green"
                v-if="selectedEvent.flavor=='audio'"
                :to="{name:'product_edit_audio',params:{id:selectedEvent.id} }"
                target="_blank"
              >
                Abrir
              </v-btn>
              <v-btn
                text
                color="secondary"
                @click="selectedOpen = false"
              >
                Fechar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>

      </v-sheet>
  


        

    </v-sheet>
</template>

<script>
import ProductService from "../../../app/rest/products"

var productService = null;

export default {
    components:{ },
    data: () => ({
        search: '',
        products:[],
        today: null,
        focus: null,
        type: 'month',
        start: null,
        end: null,
        selectedEvent: {},
        selectedElement: null,
        selectedOpen: false,
        events: [],
        headers: [
          {
            text: 'Capa',
            align: 'left',
            sortable: false,
            value: 'cover',
          },
          { text: 'Nome', value: 'name' },
          { text: 'Artista principal', value: 'artist' },
          { text: 'UPC', value: 'upc' },         
          { text: 'Data de lançamento', value: 'release_date' },
          { text: 'Status', value: 'status' }          
        ],
    }),
    computed: {
      title () {
        const { start, end } = this
        if (!start || !end) {
          return ''
        }

        const startMonth = this.monthFormatter(start)
        const endMonth = this.monthFormatter(end)
        const suffixMonth = startMonth === endMonth ? '' : endMonth

        const startYear = start.year
        const endYear = end.year
        const suffixYear = startYear === endYear ? '' : endYear

        const startDay = start.day + this.nth(start.day)
        const endDay = end.day + this.nth(end.day)

        
        return `${startMonth} ${startYear}`
        
        
        
      },
      monthFormatter () {
        return this.$refs.calendar.getFormatter({
          timeZone: 'UTC', month: 'long',
        })
      },
    },
    mounted () {
      this.$refs.calendar.checkChange()
    },
    beforeCreate:function(){
        productService = ProductService.build();
        //mostrar no calendário apenas os produtos prontos para subir
        productService.get_all({status:'published'}).then( e =>{
            if(e.status=="ok"){
                this.products = e.items.products;
                this.events = e.items.products.map( (e,i)=>{
                    var x = {};
                    x.name = e.name;
                    x.start = e.release_date;
                    x.thumb = e.thumbnail;
                    x.flavor = e.flavor;
                    x.id = e.id;
                    x.details = "";
                    if(e.artist){
                      x.details = 'Artista Principal: ' +e.artist.name;
                    }
                    x.details +=`<br>UPC:${e.upc}<br>ID: ${e.id}`;
                    var color = e.flavor;
                    x.color = color.replace("audio", "indigo").replace("video", "red");
                    
                    return x;
                });
                console.log("eventos", this.events);
            }

        }).catch( e =>{
            console.log(e);
        }).finally( () =>{
            
        });
    },
    created:function(){
        this.today = this.get_date();
        this.focus = this.get_date();
      
    },
    methods:{
        get_date(){
            var currentDateWithFormat = new Date().toJSON().slice(0,10).replace(/-/g,'-');
            return currentDateWithFormat;
        },
        get_cover_url(url){
            return process.env.VUE_APP_BASE_URL + url;
        },
        viewDay ({ date }) {
        this.focus = date
        this.type = 'day'
      },
      getEventColor (event) {
        return event.color
      },
      setToday () {
        this.focus = this.today
      },
      prev () {
        this.$refs.calendar.prev()
      },
      next () {
        this.$refs.calendar.next()
      },
      showEvent ({ nativeEvent, event }) {
        const open = () => {
          this.selectedEvent = event
          this.selectedElement = nativeEvent.target
          setTimeout(() => this.selectedOpen = true, 10)
        }

        if (this.selectedOpen) {
          this.selectedOpen = false
          setTimeout(open, 10)
        } else {
          open()
        }

        nativeEvent.stopPropagation()
      },
      updateRange ({ start, end }) {
        // You could load events from an outside source (like database) now that we have the start and end dates on the calendar
        this.start = start
        this.end = end
      },
      nth (d) {
        return d > 3 && d < 21
          ? 'th'
          : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][d % 10]
      },
    }
};
</script>